import { UpOutlined } from '@ant-design/icons';
import { Checkbox, Typography } from 'antd';
import { useCallback, useState } from 'react';

import Button from '~/shared/components/form-fields/button';
import Link from '~/shared/components/link';
import { getLocaleLink } from '~/shared/helpers/browser-helpers';
import { getDate, getUrl } from '~/shared/helpers/string-helpers';
import type { CourseType } from '~/shared/types/course-type';
import type { I18nextOptionsType } from '~/shared/types/i18n-type';

import '~/shared/components/items-navigator/components/banner-row-item/banner-row-item.scss';

import noImage from '~/assets/no-image.webp';

const { Paragraph } = Typography;

type BannerRowItemPropsType = {
  isMobile: boolean;
  data: CourseType;
  config?: {
    user: {
      courses: CourseType[];
      isAuthenticated: boolean;
    };
  };
  pageToGo: string;
  pageTagsToGo?: string;
  t: (key: string, options: I18nextOptionsType) => string;
};

const BannerRowItem = ({ isMobile, lng, pageToGo, config, data, t }: BannerRowItemPropsType) => {
  const [isPaymentContainerShowed, changePaymentContainerStatus] = useState(false);
  // const [isSignInForm, switchForm] = useState(true);
  const [isAgree, switchAgreementCheckbox] = useState(true);
  const isPaid = (config?.user.courses ?? []).findIndex((course: CourseType) => course._id === data?._id) >= 0;

  /*    if (isBrowser()) {
  /*    useEffect(() => {
        if (!isPaid) {
          setTimeout(async () => {
            /!*   await liqPayCheckoutCallback({
              course: props?.data,
              intl: props?.intl,
              userStartCourse: props?.userStartCourse,
              history: props?.history
            } ); *!/
          }, 1000);
        }
      }, [isPaymentContainerShowed, config?.user?.isAuthenticated]);
  } */
  const [expand, setExpand] = useState(false);

  return (
    <article itemProp="blogPosts" itemScope itemType="http://schema.org/BlogPosting" className="banner-row-item">
      <div className="banner-row-item__left-side">
        <link itemProp="image" href={data?.thumbnail?.path ?? noImage.src} />
        <div
          className="row-block__image"
          style={{
            background: `url(${data?.image?.path ?? noImage.src}) center/cover no-repeat`,
          }}
        />
        <h4 className="banner-row-item__price">
          {data?.price ?? 0}&nbsp;
          {t(`text.${data?.currency ?? 'uah'}`)}
        </h4>
        {isPaid && <div className="banner-row-item__paid">{t('text.you-paid-for-this-course')}</div>}
        <div className="banner-row-item__actions">
          {isPaid && (
            <Button href={getLocaleLink(getUrl({ link: pageToGo, alias: data?.alias }), lng)}>
              {t('button.go-to-course')}
            </Button>
          )}
          {!isPaid && (
            <div className="banner-row-item__payment">
              <div className="row-block__agreement-with-service-provider">
                <Checkbox checked={isAgree} onChange={() => switchAgreementCheckbox(!isAgree)} />
                <p
                  dangerouslySetInnerHTML={{
                    __html: t('text.agreement-with-service-provider', {
                      ns: ['text'],
                    }),
                  }}
                />
              </div>
              <div
                className="row-block__buy-course-button"
                onClick={useCallback(() => {
                  isAgree && changePaymentContainerStatus(true);
                }, [isAgree, changePaymentContainerStatus])}
              >
                {t('button.buy-course')}
              </div>
              <div className="row-block__master-card" />
            </div>
          )}
        </div>
      </div>
      <div className="row-block__right-side">
        <h2 className="row-block__title">
          <Link href={getLocaleLink(getUrl({ link: pageToGo, alias: data?.alias }), lng)}>{data?.title}</Link>
        </h2>
        <div className="row-block__content">
          {data?.createdAt && (
            <div>
              <span>{getDate(data?.createdAt)}</span>
            </div>
          )}
          <div>
            <Paragraph
              ellipsis={
                !expand
                  ? {
                      expandable: false,
                      rows: 3,
                    }
                  : false
              }
            >
              <div
                itemProp="description"
                className="row-block__html-content"
                dangerouslySetInnerHTML={{
                  __html: data?.description,
                }}
              />
            </Paragraph>
            <Button type="link" className="full-width small" onClick={() => setExpand((prev) => !prev)}>
              {' '}
              {expand ? t('button.collapse') : t('button.expand')}
              <UpOutlined
                style={{
                  transform: `rotate( ${expand ? '0deg' : '-180deg'})`,
                  transition: 'transform 0.25s',
                }}
              />
            </Button>
            <div className="row-block__player"></div>
          </div>
          {!isPaid && isAgree && isPaymentContainerShowed && !config?.user?.isAuthenticated ? (
            <div></div>
          ) : (
            !isPaid &&
            isAgree &&
            isPaymentContainerShowed && (
              <div>
                <div id="liqpay_checkout" />
              </div>
            )
          )}
        </div>
      </div>
    </article>
  );
};

export default BannerRowItem;
